export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Latin1-08e0f776b29f3c80777f8dc2623b8419.woff";